import TablePagination from "@material-ui/core/TablePagination";
import Delete from "@material-ui/icons/Delete";
import Visibility from "@material-ui/icons/Visibility";
import MaterialTable from "material-table";
import React from "react";
//https://stackoverflow.com/questions/57186980/search-not-working-with-react-material-table-using-remote-data

export default function Table(props) {
	const [state, setState] = React.useState(props.Inputs);
	console.log("state in Table=", state);
	console.log("props.totalRow=", props.totalRow);
	console.log("MaterialTable data=", state.data);
	console.log("MaterialTable props.firstLoad=", props.firstLoad);
	console.log("MaterialTable props=", props);

	return (
		<>
			{state.title && state.data.length > 0 && (
				<>
					<MaterialTable
						title={state.title}
						columns={state.columns}
						data={state.data}
						actions={
							props.showActions
								? [
										(rowData) => ({
											icon: () => (
												<Delete
													color={
														!rowData.deleteDisabled ? "inherit" : "disabled"
													}
												/>
											),
											tooltip: "Delete Document",
											onClick: (event, rowData) => {
												if (!rowData.deleteDisabled) {
													props.handleDeleteDocument(rowData);

													// do stuff
												} else {
													return null;
												}
											},
										}),
										(rowData) => ({
											icon: () => (
												<Visibility
													color={!rowData.viewDisabled ? "inherit" : "disabled"}
												/>
											),
											tooltip: "More Info",
											onClick: (event, rowData) => {
												if (!rowData.viewDisabled) {
													{
														props.handleChange(this, "two", rowData.id);
														console.log(
															"Table handle change clicked owData.id=",
															rowData.id
														);
													}
													console.log(("rowData.id=", rowData.id));
													// do stuff
												} else {
													return null;
												}
											},
										}),
								  ]
								: []
						}
						options={{
							paging: false,
							search: props.showSearch,
						}}
					/>

					{props.showCustomizedToolbar && (
						<table>
							<tbody>
								<tr>
									<TablePagination
										//rowsPerPageOptions={[5, 10, 20, 30]}
										rowsPerPage={props.numberRowPerPage}
										count={props.totalRow}
										page={props.pageNumber - 1}
										onChangePage={(e, page) => {
											console.log("onChangePage=", e);
											props.handleChangeTablePage(page);
											console.log("onChangePage page=", page);
										}}
										onChangeRowsPerPage={(event) => {
											console.log(
												"onChangeRowsPerPage event.target.value=",
												event
											);
											//props.onChangeTableRowsPerPage(event);
											//this.handleChangeRowPerPage(event.target.value);
										}}
									/>
								</tr>
							</tbody>
						</table>
					)}
				</>
			)}
		</>
	);
}
